import { Button } from '@mui/material';
import { useContext } from 'react';
import { DATA_TEST } from './enums';
import { ResultContext, sizeStyles } from './ResultContext';
import type { ResultButtonProps } from './types';

/**
 * Renders a button for the Result component, with responsive sizing.
 */
export const ResultButton = ({
  variant = 'outlined',
  color = 'primary',
  size,
  onClick,
  children,
  sx = {},
  ...props
}: ResultButtonProps) => {
  const context = useContext(ResultContext);
  if (!context) throw new Error('ResultButton must be used within an Result component');

  const { size: contextSize, isMobile } = context;
  const buttonSize = size ?? sizeStyles(contextSize, isMobile).buttonSize;

  return (
    <Button
      variant={variant}
      color={color}
      size={buttonSize}
      onClick={onClick}
      sx={sx}
      data-test={DATA_TEST.result_button}
      {...props}
    >
      {children}
    </Button>
  );
};
